import React from "react";
import { Box, Container, Typography } from "@mui/material";
import { Seo } from "src/components/seo";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { error: error, hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error("Error caught by Error Boundary:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <>
          <Seo title="LSANK WQMS: Error Occured" />
          <Box
            component="main"
            sx={{
              alignItems: "center",
              display: "flex",
              flexGrow: 1,
              height: "100%",
              py: "20vh",
            }}
          >
            <Container maxWidth="lg">
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  mb: 6,
                }}
              >
                <Box
                  alt="Not found"
                  component="img"
                  src="/assets/errors/error-404.png"
                  sx={{
                    height: "auto",
                    maxWidth: "100%",
                    width: 400,
                  }}
                />
              </Box>
              <Typography
                align="center"
                variant={"h4"}
              >
                {"Error"}
              </Typography>
              <Typography
                align="center"
                color="text.secondary"
                sx={{ mt: 0.5 }}
              >
                {
                  "Client-side error has occured. Please check browser console for details"
                }
                .
              </Typography>
            </Container>
          </Box>
        </>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
